import { ChevronLeft, ChevronRight } from "lucide-react";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const DOW = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function dateStr(year, month, day) {
  return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export default function MiniCalendar({ year, month, onNavigate, dayContent, testid = "mini-calendar" }) {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const offset = (new Date(year, month, 1).getDay() + 6) % 7;
  const cells = [...Array(offset).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];

  return (
    <div data-testid={testid} className="border border-border bg-white">
      <div className="flex items-center justify-between border-b border-border px-4 py-2.5">
        <p className="font-heading text-sm font-bold uppercase tracking-[0.15em]">{MONTHS[month]} {year}</p>
        <div className="flex gap-1">
          <button data-testid={`${testid}-prev`} onClick={() => onNavigate(-1)} className="flex h-7 w-7 items-center justify-center border border-border transition-colors duration-150 hover:bg-muted"><ChevronLeft className="h-4 w-4" /></button>
          <button data-testid={`${testid}-next`} onClick={() => onNavigate(1)} className="flex h-7 w-7 items-center justify-center border border-border transition-colors duration-150 hover:bg-muted"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      <div className="grid grid-cols-7">
        {DOW.map((d) => <div key={d} className="border-b border-border px-1 py-1.5 text-center text-[10px] font-semibold uppercase tracking-[0.15em] text-muted-foreground">{d}</div>)}
        {cells.map((d, i) => (
          <div key={i} className={`min-h-[72px] border-b border-r border-border p-1.5 [&:nth-child(7n)]:border-r-0 ${d ? "" : "bg-muted/30"}`}>
            {d && (
              <>
                <p className="text-xs font-semibold text-muted-foreground tabular-nums">{d}</p>
                <div className="mt-1 space-y-1">{dayContent && dayContent(dateStr(year, month, d), d)}</div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
